// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_notfoundbackbutton3 = /** @type {(inputs: {}) => string} */ () => {
	return `Go to Dashboard`
};

const de_notfoundbackbutton3 = /** @type {(inputs: {}) => string} */ () => {
	return `Zum Dashboard`
};

const es_notfoundbackbutton3 = /** @type {(inputs: {}) => string} */ () => {
	return `Ir al Tablero`
};

const fr_notfoundbackbutton3 = /** @type {(inputs: {}) => string} */ () => {
	return `Aller au Tableau de Bord`
};

const ja_notfoundbackbutton3 = /** @type {(inputs: {}) => string} */ () => {
	return `ダッシュボードに戻る`
};

const nl_notfoundbackbutton3 = /** @type {(inputs: {}) => string} */ () => {
	return `Ga naar Dashboard`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "ja" | "nl" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const notfoundbackbutton3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.notfoundbackbutton3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("notfoundbackbutton3", locale)
	if (locale === "en") return en_notfoundbackbutton3(inputs)
	if (locale === "de") return de_notfoundbackbutton3(inputs)
	if (locale === "es") return es_notfoundbackbutton3(inputs)
	if (locale === "fr") return fr_notfoundbackbutton3(inputs)
	if (locale === "ja") return ja_notfoundbackbutton3(inputs)
	return nl_notfoundbackbutton3(inputs)
};
export { notfoundbackbutton3 as "notFoundBackButton" }